
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/grampus-202209",
      function () {
        return require("private-next-pages/campaign/grampus-202209/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/grampus-202209"])
      });
    }
  